export default __webpack_public_path__ + "4f674ca9262243cf58adae4299ae99e4.png";